<template>
  <div class="table-header">
    <div class="table-header-left" v-if="showTableTitle">
      <slot name="tableTitle"></slot>
    </div>
    <div class="table-header-right" v-if="showTableButton || showTableOptions">
      <div class="table-right-button" v-if="showTableButton">
        <slot name="tableButton"></slot>
      </div>
      <div class="table-settings" v-if="showTableOptions">
        <TableSetting />
      </div>
    </div>
  </div>
</template>

<script>
import TableSetting from "./../Settings";
export default {
  components: { TableSetting },
  computed: {},
  props: {
    showTableOptions: {
      type: Boolean,
      default: false,
    },
    showTableTitle: {
      type: Boolean,
      default: false,
    },
    showTableButton: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    // this.getCategory();
    // console.log(this.$scopedSlots);
  },
  data() {
    return {
      userInfo: {
        name: "admin",
      },
      isMobile: false,
    };
  },
  methods: {},
};
</script>
<style lang="less">
@import "./style.less";
</style>
